/**
 * Демо-хранилище — глобальный стейт для демо-режима.
 * В продакшене будет заменено на Supabase.
 */

// Рабочие записи
export const demoStorage = {
  acceptances: [],
  returns: [],
  issued: [],
}

// Настройки расчёта ЗП
export const salaryConfig = {
  dailyRate: 1500,       // Ставка за смену (₽)
  bonusPerAccepted: 5,   // Бонус за принятый товар (₽/шт)
  bonusPerIssued: 3,     // Бонус за выданный товар (₽/шт)
}

// Демо-сотрудники
export const demoEmployees = [
  { id: 'demo-owner', name: 'Владелец ПВЗ' },
  { id: 'demo-admin', name: 'Управляющая Анна' },
  { id: 'demo-emp', name: 'Сотрудник Иван' },
]

/**
 * Подсчитать автоматическую зарплату сотрудника за период
 */
export function calculateAutoSalary(employeeId, periodStart, periodEnd) {
  const config = salaryConfig

  // Фильтр по сотруднику и периоду
  const inRange = (rec) => {
    if (rec.employee_id !== employeeId) return false
    if (periodStart && rec.work_date < periodStart) return false
    if (periodEnd && rec.work_date > periodEnd) return false
    return true
  }

  // Приёмки — считаем количество принятых товаров
  const acceptances = demoStorage.acceptances.filter(inRange)
  const totalAccepted = acceptances.reduce((s, r) => s + (r.count || 0), 0)

  // Выдачи — считаем количество выданных товаров
  const issued = demoStorage.issued.filter(inRange)
  const totalIssued = issued.reduce((s, r) => s + (r.count || 0), 0)

  // Уникальные рабочие дни (из всех типов записей)
  const workDays = new Set()
  acceptances.forEach(r => workDays.add(r.work_date))
  issued.forEach(r => workDays.add(r.work_date))
  demoStorage.returns.filter(inRange).forEach(r => workDays.add(r.work_date))

  const daysWorked = workDays.size

  // Расчёт
  const basePay = daysWorked * config.dailyRate
  const acceptBonus = totalAccepted * config.bonusPerAccepted
  const issuedBonus = totalIssued * config.bonusPerIssued
  const total = basePay + acceptBonus + issuedBonus

  return {
    daysWorked,
    totalAccepted,
    totalIssued,
    basePay,
    acceptBonus,
    issuedBonus,
    total,
    config: { ...config },
  }
}
